document.addEventListener("DOMContentLoaded", function(){

  const container = document.getElementById("reviewsGrid");
  const button = document.getElementById("loadMoreReviews");

  if(!container || !button) return;

  let reviews = [];
  let index = 0;
  let limit = 20;


  function stars(num){
    num = Number(num) || 5;
    return "★".repeat(num) + "☆".repeat(5-num);
  }


  function renderReviews(){

    reviews.slice(index,index+limit).forEach(item=>{

      let letter = item.name 
      ? item.name.charAt(0).toUpperCase()
      : "?";


      let avatar = item.image
      ? `<img class="custom-reviews__avatar-img" src="${item.image}">`
      : `<div class="custom-reviews__avatar">${letter}</div>`;


      let div = document.createElement("div");

      div.className = "custom-reviews__card";


      div.innerHTML = `

        <div class="custom-reviews__header">

          ${avatar}

          <div>
            <h3 class="custom-reviews__name">
              ${item.name || "Customer"}
            </h3>

            <div class="custom-reviews__date">
              Sent on ${item.date || ""}
            </div>
          </div>

        </div>


        <div class="custom-reviews__stars">
          ${stars(item.rating)}
        </div>


        <p class="custom-reviews__text">
          ${item.review || ""}
        </p>

      `;


      container.appendChild(div);

    });


    index += limit;


    if(index >= reviews.length){
      button.style.display="none";
    }

  }



  fetch(window.reviewJsonUrl)

  .then(response=>{

    if(!response.ok){
      throw new Error("JSON not found");
    }

    return response.json();

  })

  .then(data=>{

    reviews = data;

    container.innerHTML="";

    renderReviews();

  })

  .catch(error=>{

    console.log("Review JSON issue:",error);

  });


  button.addEventListener(
    "click",
    renderReviews
  );


});